/**
 * Blog category filter + infinite-style "Load more"
 *
 * - Category pill clicks → replace #blog-results (AJAX swap)
 * - "Load more" click     → append new cards to existing grid,
 *                           swap only the load-more button
 *
 * Reuses the same #collection-loader overlay already in the section.
 */
(function () {
  const SECTION_ID = 'main-blog';
  const RESULTS_ID = 'blog-results';

  // ── Loader ──────────────────────────────────────────────────────────────
  function setLoading(on) {
    const overlay = document.getElementById('collection-loader');
    if (!overlay) return;
    if (on) {
      overlay.style.display = 'grid';
      requestAnimationFrame(() => {
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'auto';
      });
    } else {
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
      overlay.addEventListener(
        'transitionend',
        () => {
          overlay.style.display = 'none';
        },
        { once: true },
      );
    }
  }

  // ── Fetch helpers ────────────────────────────────────────────────────────
  async function fetchSection(url) {
    const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}sections=${SECTION_ID}`;
    const response = await fetch(fetchUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    const html = data[SECTION_ID];
    if (!html) throw new Error('Section not found in response');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc;
  }

  // ── Category filter: replace entire #blog-results ───────────────────────
  async function applyFilter(url) {
    const container = document.getElementById(RESULTS_ID);
    if (!container) return;

    setLoading(true);
    try {
      const doc = await fetchSection(url);
      const newResults = doc.getElementById(RESULTS_ID);
      if (newResults) container.innerHTML = newResults.innerHTML;
      history.pushState({}, '', url);
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      bindLinks();
    } catch (err) {
      console.error('[blog-filter] filter error:', err);
      window.location = url;
    } finally {
      setLoading(false);
    }
  }

  // ── Load more: append cards, swap the load-more button ──────────────────
  async function loadMore(url, triggerEl) {
    const container = document.getElementById(RESULTS_ID);
    if (!container) return;

    // Swap button text to show progress
    const originalText = triggerEl.textContent;
    triggerEl.textContent = 'Loading…';
    triggerEl.style.pointerEvents = 'none';
    triggerEl.style.opacity = '0.6';

    setLoading(true);
    try {
      const doc = await fetchSection(url);
      const newResults = doc.getElementById(RESULTS_ID);
      if (!newResults) return;

      // Extract and append new article cards
      const existingGrid = container.querySelector('.blog-grid');
      const newGrid = newResults.querySelector('.blog-grid');
      if (existingGrid && newGrid) {
        newGrid.querySelectorAll('a[data-article-card]').forEach((card) => {
          existingGrid.appendChild(card);
        });
      }

      // Replace the load-more wrapper with the new page's version
      const existingMore = container.querySelector('[data-load-more-wrap]');
      const newMore = newResults.querySelector('[data-load-more-wrap]');
      if (existingMore) {
        if (newMore) {
          existingMore.replaceWith(newMore);
        } else {
          existingMore.remove();
        }
      }

      history.pushState({}, '', url);
      bindLinks();
    } catch (err) {
      console.error('[blog-filter] load-more error:', err);
      // Restore button on failure
      triggerEl.textContent = originalText;
      triggerEl.style.pointerEvents = '';
      triggerEl.style.opacity = '';
    } finally {
      setLoading(false);
    }
  }

  // ── Bind links inside #blog-results ─────────────────────────────────────
  function bindLinks() {
    const container = document.getElementById(RESULTS_ID);
    if (!container) return;

    container.querySelectorAll('a[data-filter-link]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        applyFilter(link.href);
      });
    });

    container.querySelectorAll('a[data-load-more]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        loadMore(link.href, link);
      });
    });
  }

  // ── Back / forward navigation ────────────────────────────────────────────
  window.addEventListener('popstate', () => {
    applyFilter(window.location.href);
  });

  // ── Boot ─────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLinks);
  } else {
    bindLinks();
  }
})();
